export default {
  props: ['ok'],
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  methods: {
    blurra () {
      this.$el.getElementsByTagName('input')[0].blur()
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/game/question/text/text.js